import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onFocusin", "onFocusout", "onKeydown", "value"]

import AppDate from '@/classes/AppDate';
import {
  reactive,
  computed,
  watch,
  ref,
} from 'vue';

import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateField',
  props: /*#__PURE__*/_mergeModels({
    value: {},
    minDate: {},
    maxDate: {},
    disableWeekend: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel(__props, "modelValue");
const props = __props;
const datepicker = ref();
let defaultValue = undefined as Date | undefined;
if (props.value !== undefined && `${props.value || ''}`.trim() !== '') {
  defaultValue = new AppDate(props.value);
}

const field = reactive({
  date: defaultValue,
  dateText: '',
  attributes: [{
    timezone: 'Europe/Amsterdam',
  }],
  locale: 'de',
});

const formattedDateValue = computed(() => {
  if (!field.date) return null;

  return new AppDate(field.date).format('Y-m-d');
});

const emitInput = () => {
  modelValue.value = formattedDateValue.value;
};

watch(() => field.date, () => {
  emitInput();
});

const onInputKeyDown = (event: KeyboardEvent, callback: unknown) => {
  if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.'].indexOf(event.key) >= 0) {
    if (typeof callback === 'function') {
      callback();
    }
  }
};

const getDatepickerInputDate = (value: string) => {
  const datePartials = value.split('.');
  const validDateValue = datePartials.length === 3
      && (datePartials[0].length === 1 || datePartials[0].length === 2)
      && (datePartials[1].length === 1 || datePartials[1].length === 2)
      && datePartials[2].length === 4;

  if (validDateValue) {
    return new Date(
      parseInt(datePartials[2], 10),
      parseInt(datePartials[1], 10) - 1,
      parseInt(datePartials[0], 10),
    );
  }

  return undefined;
};

const updateValueByInput = (e: any) => {
  const inputDate = getDatepickerInputDate(e?.target?.value);

  if (datepicker.value && inputDate !== undefined) {
    datepicker.value.updateValue(inputDate);
    datepicker.value.move(inputDate);
    datepicker.value.hidePopover();
  }
};

const disabledDates = computed(() => {
  if (props.disableWeekend) {
    return {
      weekdays: [
        1,
        7,
      ],
    };
  }

  return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), {
    ref_key: "datepicker",
    ref: datepicker,
    modelValue: field.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((field.date) = $event)),
    attributes: field.attributes,
    locale: field.locale,
    "max-date": _ctx.maxDate,
    "min-date": _ctx.minDate,
    "disabled-dates": disabledDates.value,
    "update-on-input": false
  }, {
    default: _withCtx(({ inputValue, hidePopover, showPopover }) => [
      _createElementVNode("input", {
        onFocusin: ($event: any) => (showPopover()),
        onFocusout: ($event: any) => (hidePopover()),
        onKeydown: ($event: any) => (onInputKeyDown($event, showPopover)),
        onKeyup: updateValueByInput,
        value: inputValue,
        maxlength: "10"
      }, null, 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue", "attributes", "locale", "max-date", "min-date", "disabled-dates"]))
}
}

})